import React from 'react';
import Input from '../Input';
import { HeadingSmall } from '../Configurator';
import './MobileFocusModal.css';

/**
 * Shared mobile focus card — a bottom sheet floating above the software keyboard.
 * Driven by `useMobileFocus` (src/hooks/useMobileFocus.js).
 *
 * `activeFocusData`: { label, placeholder, value, setValue, maxLength, helperText,
 *                      price?, icon?, error?, inputMode? } — `inputMode` picks the
 *                      keyboard (e.g. "tel", "url", "email")
 */
const MobileFocusModal = ({ focusField, activeFocusData, closeFocusMode, containerRef }) => (
  <div
    className={`mf__modal ${focusField ? 'mf__modal--active' : ''}`}
    ref={containerRef}
  >
    <div
      className="mf__backdrop"
      onPointerDown={(e) => { e.preventDefault(); closeFocusMode(); }}
    />
    <div className="mf__card">
      <HeadingSmall
        title={activeFocusData.label}
        showSelection={false}
        price={activeFocusData.price}
      />
      <form
        action="#"
        onSubmit={(e) => {
          e.preventDefault();
          document.getElementById('mf-input')?.blur();
          closeFocusMode();
        }}
        style={{ width: '100%', margin: 0, padding: 0 }}
      >
        <Input
          id="mf-input"
          type="action"
          onAction={() => closeFocusMode()}
          icon={activeFocusData.icon ?? null}
          showIcon={Boolean(activeFocusData.icon)}
          placeholder={activeFocusData.placeholder}
          label={activeFocusData.placeholder}
          value={activeFocusData.value}
          onChange={(e) => activeFocusData.setValue(e.target.value)}
          maxLength={activeFocusData.maxLength}
          inputMode={activeFocusData.inputMode}
          helperText={activeFocusData.helperText}
          error={activeFocusData.error || ''}
          showClear={false}
          enterKeyHint="done"
          onBlur={() => setTimeout(closeFocusMode, 150)}
          onKeyUp={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); closeFocusMode(); }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); closeFocusMode(); }
          }}
        />
      </form>
    </div>
  </div>
);

export default MobileFocusModal;
